<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.7215 7.59688C13.2402 4.47656 11.0012 2.90625 7.9996 2.90625C4.99648 2.90625 2.75898 4.47656 1.27773 7.59844C1.21831 7.72425 1.1875 7.86165 1.1875 8.00078C1.1875 8.13991 1.21831 8.27732 1.27773 8.40312C2.75898 11.5234 4.99804 13.0938 7.9996 13.0938C11.0027 13.0938 13.2402 11.5234 14.7215 8.40156C14.8418 8.14844 14.8418 7.85469 14.7215 7.59688ZM7.9996 11.9688C5.47929 11.9688 3.63398 10.6906 2.33241 8C3.63398 5.30938 5.47929 4.03125 7.9996 4.03125C10.5199 4.03125 12.3652 5.30938 13.6668 8C12.3668 10.6906 10.5215 11.9688 7.9996 11.9688ZM7.9371 5.25C6.41835 5.25 5.1871 6.48125 5.1871 8C5.1871 9.51875 6.41835 10.75 7.9371 10.75C9.45585 10.75 10.6871 9.51875 10.6871 8C10.6871 6.48125 9.45585 5.25 7.9371 5.25ZM7.9371 9.75C6.96991 9.75 6.1871 8.96719 6.1871 8C6.1871 7.03281 6.96991 6.25 7.9371 6.25C8.90429 6.25 9.6871 7.03281 9.6871 8C9.6871 8.96719 8.90429 9.75 7.9371 9.75Z"
      fill="currentColor"
    />
    <path d="M1 1L14 14" stroke="currentColor" />
  </svg>
</template>

<script>
export default {
  name: 'IconEyeView',
};
</script>
